import React from "react";
import "./PrivacyPolice.css";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
function PrivacyPolicy() {
  return (
    <div className="terms-bg">
      <Header />
      <div className="terms-container container ">
        <div className="terms-header container">
          <h1>Privacy Notice</h1>
        </div>

        <div className="terms-content">
          <p>
            We encourage you to read this Privacy Notice in full to ensure you
            fully understand how your information is handled. However, if you're
            looking for specific details, you can easily navigate to the
            relevant sections using the provided quick links.
          </p>
          <h2>What does Qflyers do?</h2>
          <p>
            Qflyers serves as a launchpad for your latest content, including
            videos, articles, recipes, tours, online stores, websites, and
            social media posts. Our platform helps connect your audience
            seamlessly to all your online destinations, making your content more
            accessible and easier to manage. Through our website, available at
            https://qflyers.com/, and other digital properties such as our
            mobile app and Developer Portal, individuals and businesses can sign
            up to use Qflyers in various ways. Users can create a digital menu
            card or a customizable page, while subscribers can follow and engage
            with Qflyers Users. Additionally, developers can build integrations
            and functionalities that interact with our platform. Collectively,
            these services are known as the Qflyers Services.
          </p>
          <p>
            The pages created by Qflyers Users, known as User Profiles, are
            publicly accessible and serve as a digital hub for content sharing
            and audience engagement. Our headquarters is located in Coimbatore,
            Tamil Nadu, India. If you would like to learn more about us, please
            visit the About section on our website at
            https://qflyers.com/about/.
          </p>
          <h2>How does this Privacy Notice apply to me? </h2>
          <p>
            This Privacy Notice applies specifically to the personal information
            collected by Qflyers in its role as a data controller. This means
            that Qflyers determines the purposes and methods for processing
            personal information. It covers various groups of individuals,
            including visitors who browse the Qflyers platform, individuals or
            company representatives who sign up for either a paid or free
            Qflyers plan (collectively referred to as Qflyers Users),
            subscribers who follow and engage with User Profiles, and
            individuals who visit and interact with these profiles (Profile
            Visitors). Additionally, it extends to developers who register with
            the Qflyers Developer Portal to create functionalities that
            integrate with Qflyers Services, as well as individuals who
            participate in Qflyers surveys, marketing campaigns, trade
            promotions, or competitions. However, due to the nature of our
            services, Qflyers also acts as a data processor in certain
            instances, meaning that we may process personal information on
            behalf of Qflyers Users when instructed to do so. This processing
            applies particularly to the personal information of Profile Visitors
            and Subscribers. In such cases, this Privacy Notice does not govern
            how that data is handled. Instead, Profile Visitors and Subscribers
            should directly contact the Qflyers User who operates the profile
            they interacted with or refer to any privacy policies associated
            with that specific User Profile. If an individual provides Qflyers
            with personal information about another person, such as when acting
            as a representative of someone else, they are responsible for
            sharing this Privacy Notice with that person and informing them that
            their information will be processed in accordance with the policies
            outlined here.
          </p>
          <h2>Information You Provide Voluntarily</h2>
          <p>
            When you sign up to use Qflyers as a user, subscriber, or developer,
            interact with our services, visit our platform, or participate in
            surveys or promotions, we may ask you to provide certain personal
            information. For example, Free Plan Users are required to provide
            their email address, name, username, hashed password, industry type,
            and marketing preferences. Paid Plan Users must additionally provide
            billing information such as their full name, billing email, billing
            address, and payment method. If you sign up as a subscriber, you may
            be asked to provide your email address or SMS number. You can opt
            out of receiving marketing communications at any time by clicking
            the unsubscribe or opt-out link in our emails or SMS messages.
            Additionally, if you submit inquiries, report intellectual property
            issues, or respond to surveys, you may be required to provide
            personal details such as your name, email address, or other relevant
            information. Profile Visitors may also be asked by Qflyers Users to
            provide personal details like email addresses, mobile numbers, or
            dates of birth to access certain content. We use the data collected
            for service improvement and aggregated analytics to enhance the
            platform’s functionality.
          </p>
          <h2>Information That We Collect Automatically</h2>
          <p>
            When you visit the Qflyers platform, interact with user profiles, or
            participate in promotions, we automatically collect certain
            technical and usage-related information. This may include your IP
            address, device type, browser type, location (such as country or
            city), time zone, and diagnostic data. We also track interactions
            with our platform, such as the pages you visit and links you click.
            This information helps us understand user behavior, improve our
            services, and provide personalized recommendations. We may collect
            this data through cookies and tracking technologies, as explained
            further in our cookie policy. Additionally, we scan user profiles
            and links to detect sensitive or inappropriate content and enforce
            community standards. If a user updates their profile, their
            subscribers may receive notifications about the changes.
          </p>
          <h2>Information That We Obtain from Third-Party Sources</h2>
          <p>
            We may receive personal information about you from third-party
            sources, including marketing service providers, competition
            partners, and business affiliates who help us deliver Qflyers
            services. We ensure that these third parties have your consent or a
            legal basis for sharing your data with us before obtaining any
            information. This helps us enhance our services, improve marketing
            efforts, and offer a better user experience.
          </p>
          <h2>Children’s Data</h2>
          <p>
            {" "}
            Qflyers services are not designed for individuals under the age of
            18. If you are below this age limit, you are not permitted to use
            our platform or provide personal information. If we discover that a
            minor has submitted personal data, we will take necessary steps to
            delete or destroy that information. Parents or guardians who become
            aware of such a situation should contact us immediately so that we
            can ensure compliance with our policies
          </p>
          <h2>Recruitment</h2>
          <p>
            If you apply for a job at Qflyers, your personal information will
            only be used for recruitment purposes. We store this data for a
            maximum of two years before anonymizing it for statistical purposes.
            Qflyers currently works with Ashby, Inc. for recruitment data
            collection, storage, and processing. We carefully review all
            third-party service providers to ensure they meet strict data
            protection standards. You can find more details about Ashby’s
            privacy policy at Ashby’s website.
          </p>
          <h2>Why do we collect your personal information?</h2>
          <p>
            We collect your personal information for several key purposes that
            help us provide, improve, and personalize the Qflyers Services while
            ensuring compliance with legal requirements and security measures.
            The information we collect is used as outlined in this Privacy
            Notice or as explained at the time of collection
          </p>
          <p>
            One of the primary reasons we collect your personal information is
            to provide and deliver the Qflyers Services efficiently. This
            includes assessing, maintaining, and improving the overall
            functionality and performance of the platform. By analyzing user
            interactions and technical data, we can ensure that the Qflyers
            Services operate smoothly, remain relevant to users, and adapt to
            evolving technological and business needs.
          </p>
          <p>
            Additionally, we use your information to enhance the relevance of
            our services by tailoring them to your device, preferences, and
            location. This allows us to deliver personalized content, localized
            updates, and relevant notifications about changes to the platform
            that may affect your experience. Our goal is to create a seamless
            and customized user experience that aligns with your interests and
            expectations. We also conduct consumer research to understand user
            behavior and preferences better. This includes collecting insights
            through surveys and interactive features on the platform. By
            voluntarily participating in these activities, you help us refine
            our services, introduce new features, and make data-driven
            improvements that benefit the entire Qflyers community.
          </p>
          <p>
            Your personal information enables us to provide customer support and
            address any inquiries, complaints, or intellectual property concerns
            you may have. Whether you need assistance with your account, a
            technical issue, or legal matters such as intellectual property
            disputes, we use your data to process and respond to requests
            efficiently, ensuring a smooth resolution process
          </p>
          <p>
            To maintain the platform’s stability and prevent disruptions, we
            monitor usage patterns and detect potential technical issues. This
            proactive approach allows us to identify, prevent, and address any
            system malfunctions, security threats, or service outages before
            they impact users.
          </p>
          <p>
            For Paid Plan Users, we collect and process payment information to
            facilitate transactions securely. This includes billing details such
            as name, billing address, and payment methods, ensuring seamless and
            protected financial transactions while maintaining compliance with
            applicable regulations. We also use personal information for
            internal business operations, including strategic planning,
            reporting, and forecasting. This helps us analyze market trends,
            optimize our services, and make informed business decisions that
            contribute to our long-term growth and sustainability.
          </p>
          <p>
            Marketing and promotional activities are another important aspect of
            how we use your personal information. If you have previously
            purchased or inquired about our services, we may send you
            promotional materials, special offers, and updates about similar
            products or events unless you opt out. These communications aim to
            keep you informed about opportunities that may be of interest to
            you.
          </p>
          <p>
            Ensuring legal compliance is crucial, and we use personal
            information to manage our business obligations, fulfill our rights,
            respond to law enforcement requests, and defend against legal claims
            when necessary. This helps us maintain transparency, meet regulatory
            requirements, and safeguard the integrity of the Qflyers Services.
          </p>
          <p>
            To protect against fraudulent activities, we verify user identities
            and monitor transactions for suspicious behavior. This includes
            detecting and preventing fraudulent payments, unauthorized access,
            and misuse of the Qflyers platform, ensuring a secure environment
            for all users.
          </p>
          <h2>Legal Basis for Processing Personal Information</h2>
          <p>
            The legal basis for collecting and processing personal information
            varies depending on the specific type of data involved and the
            circumstances under which it is gathered. In most cases, Qflyers
            processes personal information only when there is a valid legal
            reason to do so. Typically, we collect personal information based on
            one or more of the following legal grounds: with your explicit
            consent, as necessary to fulfill a contractual obligation, or
            because the processing serves our legitimate interests without
            overriding your fundamental rights and freedoms. In certain
            instances, we may also be legally required to collect and store
            personal data, or we may need to process information to protect your
            vital interests or those of another individual.
          </p>
          <p>
            When we request personal information to comply with a legal
            obligation, we ensure that this is clearly communicated at the point
            of collection. We also inform you whether providing the requested
            data is mandatory and explain any potential consequences of refusing
            to share such information.
          </p>
          <p>
            If we process your personal information based on our legitimate
            interests (or those of a third party), these interests generally
            revolve around enhancing and improving the Qflyers Services,
            introducing new functionalities, maintaining platform security, and
            implementing content moderation measures, such as sensitive content
            warnings. However, if we rely on another legitimate interest beyond
            these standard cases, we will clearly outline the specific purpose
            for processing your data at the relevant time.
          </p>
          <h2>Who May We Disclose Your Personal Information To?</h2>
          <p>
            We may share your personal information with specific categories of
            recipients to ensure the smooth functioning of Qflyers Services and
            to comply with legal or contractual obligations. These recipients
            include:
          </p>
          <p>
            {" "}
            Our Group Companies: We may disclose your personal data to our
            affiliated entities or subsidiaries that assist in managing and
            operating Qflyers Services. These group companies help in the
            development, support, and enhancement of our platform. Third-Party
            Service Providers: We engage third-party service providers to assist
            in delivering Qflyers Services, improving platform functionality,
            maintaining security, and providing other necessary support. These
            service providers process personal information strictly for the
            purposes outlined in this Privacy Notice or any additional notices
            shared with you when your information is collected.
          </p>
          <p>
            Business Partners and External Platforms: We collaborate with
            partners who integrate with Qflyers Services, enhance its features,
            or facilitate interactions between users and the platform. This may
            include analytics providers, marketing partners, and cloud service
            providers.
          </p>
          <p>
            The countries in which these organisations are located will vary,
            but, in the course of our business operations, we generally disclose
            personal information to organisations located in Australia, or the
            United States. Such transfers are made in order to provide the
            Qflyers Services and carry out the activities specified in this
            Privacy Notice
          </p>
          <h2>Complaints</h2>
          <p>We value your privacy and are committed to addressing any concerns regarding the handling of your personal information. If you have a complaint about our privacy practices, data processing methods, or a potential violation of your rights, you may file a complaint using the contact details provided below. Once we receive your complaint, we will acknowledge receipt and initiate an internal investigation if necessary. In some cases, we may request additional details to better understand your concern. If we determine that a privacy breach has occurred, we will take corrective measures and inform you of the outcome. If you are not satisfied with our response, you may escalate your complaint to the relevant data protection authority in your jurisdiction.</p>
          <h2>Changes to This Privacy Notice</h2>
          <p>We may update this Privacy Notice periodically to reflect changes in legal, technical, or business developments. Whenever significant updates are made, we will notify you through appropriate means, such as email or platform notifications. If any changes require your consent under applicable data protection laws, we will seek your approval before implementing them. The most recent version of our Privacy Notice will always be available on our platform, and you can check the "last updated" date to determine when the latest changes were made.</p>
          <h2>
          Contact Us
          </h2>
          <p>If you have any questions about this Privacy Notice, our data protection practices, or if you want to exercise your rights related to personal information, you can contact us through the following channels</p>
          <ul>
            <li>
            	By Email: support@qflyers.com
            </li>
            <li>Through Our Platform: Visit our Help Center at qflyers.com/help</li>
            <li>  	By Post: Send a written request to Qflyers Pty Ltd, 48 Covai Thirunagar, Goldwins, Coimbatore, TN, India.</li>
          </ul>
          <p>If you need further information about how we handle your personal data, including how we store, process, or use it, please reach out to us using the contact details provided above</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
